﻿export default class ImageRenderer {
	canRender(document) {
		const extensions = ["png", "PNG", "jpg", "JPG", "webp", "WEBP", "jpeg", "JPEG"];

		return extensions.includes(document.extension);
	}

	render(doc) {
		const $container = document.createElement("div");
		const $title = document.createElement("div");
		const $img = document.createElement("img");

		$container.className = "performance-curve";
		$title.className = "curve-title";
		$title.innerHTML = doc.displayName;

		$img.src = doc.url;
		$img.alt = doc.displayName;

		$container.appendChild($title);
		$container.appendChild($img);

		return $container;
	}
}
